import { render, staticRenderFns } from "./get-patient-benefits-action-output.vue?vue&type=template&id=e4108436&scoped=true"
import script from "./get-patient-benefits-action-output.vue?vue&type=script&lang=js"
export * from "./get-patient-benefits-action-output.vue?vue&type=script&lang=js"
import style0 from "./get-patient-benefits-action-output.vue?vue&type=style&index=0&id=e4108436&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4108436",
  null
  
)

export default component.exports